import { cn } from '~/lib/utils';
import React, { type ReactNode } from 'react';

const SIZES = {
  'display-100': 'text-display-100',
  'display-200': 'text-display-100',
  'display-300': 'text-display-300',
  '7xl': 'text-6xl',
  '6xl': 'text-7xl',
  '5xl': 'text-5xl',
  '4xl': 'text-4xl',
  '3xl': 'text-3xl',
  '2xl': 'text-2xl',
  xl: 'text-xl',
  lg: 'text-lg',
  md: 'text-md',
  sm: 'text-sm',
  xs: 'text-xs',
};

const HEADING = {
  h1: 'text-4xl',
  h2: 'text-3xl',
  h3: 'text-2xl',
  h4: 'text-xl',
  h5: 'text-lg',
  h6: 'text-lg',
} as const;

type HeadingOption = keyof typeof HEADING;
type SizeOption = keyof typeof SIZES;

export const Heading = ({
  className,
  as: Tag = 'h2',
  // Monogram gave us really large font sizes that look poor on mobile
  // We try to set the size based on the tag used
  // Size will override that option if it doesn't look good in that space
  size = null,
  children,
}: {
  className?: string;
  size?: SizeOption | null;
  // @TODO: will type this once we update to TS 5
  as?: any;
  children: ReactNode;
}) => {
  const classSize = Object.keys(HEADING).includes(Tag) ? HEADING[Tag as HeadingOption] : null;

  return <Tag className={cn(size ? SIZES[size as SizeOption] : classSize, 'text-pretty', className)}>{children}</Tag>;
};
